// remove incomplete translations of filters and themes, to fix APP-2731
export function removeIncompleteThemeTranslations(translations) {
  Object.keys(translations).forEach(languageCode => {
    let deleteThisLanguageData = false
    if (translations[languageCode].Theme) {
      Object.values(translations[languageCode].Theme).forEach(theme => {
        if (!theme.name) {
          deleteThisLanguageData = true
        }
      })
    }
    if (deleteThisLanguageData) {
      translations[languageCode].Theme = null
    }
  })
  return translations
}
export function removeIncompleteFilterTranslations(translations) {
  Object.keys(translations).forEach(languageCode => {
    let deleteThisLanguageData = false
    if (translations[languageCode].Filters) {
      Object.values(translations[languageCode].Filters).forEach(filter => {
        if (!filter.name) {
          deleteThisLanguageData = true
        }
        if (filter.rows) {
          Object.values(filter.rows).forEach(row => {
            if (!row.name) {
              deleteThisLanguageData = true
            }
          })
        }
      })
    }
    if (deleteThisLanguageData) {
      translations[languageCode].Filters = null
    }
  })
  return translations
}
